import { type StateCreator } from 'zustand';

export type AuthSlice = {
  accessToken: string | null;
  expiresAt: string | null;
  authEmail: string | null;
  onAuthSuccess: (payload: {
    accessToken: string;
    expiresAt: string;
    authEmail?: string | null;
  }) => void;
  clearAuth: () => void;
};

export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (set) => ({
  accessToken: null,
  expiresAt: null,
  authEmail: null,
  onAuthSuccess: (payload) => {
    set((state) => ({
      ...state,
      accessToken: payload.accessToken,
      expiresAt: payload.expiresAt,
      authEmail: payload.authEmail ?? null,
    }));
  },

  clearAuth: () =>
    set((state) => ({
      ...state,
      accessToken: null,
      expiresAt: null,
      authEmail: null,
    })),
});
